<template>
 <div>
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3"></TitleCard>
            <a-card class="all-card-style " >

              <a-table   id="printTest" @change="handleTableChange" :pagination="pagination" :columns="columns"
                         :data-source="data" :row-selection="rowSelection"  style="margin-top:20px;">
          <span slot="action" slot-scope="text, record">
           <div>


             <a   @click="toDetailPage(record)"   >详情</a></div>
          </span>


              </a-table>



            </a-card>
 </div>
</template>
<script>
import TitleCard from '@/components/TitleCard.vue'
const columns = [
 { title: '所属场景', dataIndex: 'SceneName', key: 'SceneName',className:'column-money' },
  { title: '设备名称', dataIndex: 'DeviceName', key: 'DeviceName' ,className:'column-money'},
  { title: '设备别名', dataIndex: 'DeviceAsName', key: 'DeviceAsName' ,className:'column-money'},
  { title: '用电量', dataIndex: 'TotalConsume', key: 'TotalConsume',className:'column-money'},
    { title: '用水量', dataIndex: 'TotalWater', key: 'TotalWater',className:'column-money' },
  { title: '工作时长', dataIndex: 'TotalDuration', key: 'TotalDuration', className:'column-money' },
  {
      title: '操作',
      key: 'action',
      className:'column-money',
      scopedSlots: { customRender: 'action' },
    },
];

// 表格前选择
const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
  },
  onSelect: (record, selected, selectedRows) => {
    console.log(record, selected, selectedRows);
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    console.log(selected, selectedRows, changeRows);
  },
};

export default {
  name: 'logList',
  components: {
    TitleCard
  },
  data(){
    return{
      titleMsg1:"能耗分析",
      titleMsg2:'能耗分析',
      titleMsg3:'能耗分析',
      titleMsg4:'能耗分析',
      data:[

      ],
      columns,
      paramas:{
        keyword:"",
        sceneId:"",
        cEntID:"",
        page:1,
        limit:10
      },
      rowSelection,
      deleteModalVisible:false,
      pagination: {
        current:1,
        total: 0,
        pageSize: 10,//每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50", "100"],//每页中显示的数据
        showTotal: total => `共有 ${total} 条数据`,  //分页中显示总的数据
      },

      record:{},
    }
  },
  mounted () {
    let that=this;
    that.paramas.sceneId=that.$store.getters.SCene.ID;
    that.paramas.cEntID=that.$store.getters.User.enterprise.ID;

    that.$bus.$on('scenechange',(target)=> {
      that.paramas.sceneId=target.id;
      that.handlePageList();
    });
    that.handlePageList();
  },
  methods:{
    print(){
      this.$print(this.$refs.prints)
    },
    export2Excel(){

      let that=this;

      require.ensure([], () => {
        const { export_json_to_excel } = require('vendor/Export2Excel');
        //头
        const tHeader = [ '所属场景', '设备名称', '设备别名','用电量','用水量','工作时长'];
        //对应的标签
        const filterVal = ['SceneName', 'DeviceName', 'DeviceAsName','TotalConsume', 'TotalWater','TotalDuration'];
        //标签对应的内容  是一个数组结构
        const list = that.data;
        //一个方法 我也不知道干嘛的
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, '投喂excel');
      })
    },
    formatJson(filterVal, jsonData){
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.paramas.page = pagination.current;
      this.paramas.limit = pagination.pageSize;
      this.handlePageList();
    },
    async handlePageList(){
      let that=this;
      that.paramas.cSystemCode='设施园艺'
      let res= await that.$http.post('WLWDevice/EnergyConsumptionAnalysis',that.paramas)

      if(res.data.code=="200"){

        that.data= res.data.obj.list;

      }
      else{
        that.$message.error(res.message)

      }
    },

    toDetailPage(row)
    {
      console.log('row:::',row);
     // this.$router.push({path:'/productionManagement/workordermanagement/WorkOrderManagementNewAdd'})

      this.$router.push({
        path: '/energyanalsis/equipmentDetails',
        query: {
          IotId: row.IotId
          ,TotalDuration:row.TotalDuration
        }
      })

    },

  }
}


</script>
